import { render } from "./Contact.vue?vue&type=template&id=4373477c"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/components/Contact.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4373477c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4373477c', __exports__)) {
    api.reload('4373477c', __exports__)
  }
  
  module.hot.accept("./Contact.vue?vue&type=template&id=4373477c", () => {
    api.rerender('4373477c', render)
  })

}


export default __exports__